module.exports = __webpack_public_path__ + "static/media/delux02.07637672.png";